/**
 * Local days and minutes in a named zone — the calendar's arithmetic on both
 * sides (`docs/activity.md` §6). The server keeps its own copy in
 * `services/requests/clock.ts`, which these mirror; the page uses these to
 * turn a slot it drew (a date and minutes in the branch's zone, which
 * `CalendarAnswer.timeZone` names) into the instant it sends.
 */
const formats = new Map();
function formatFor(timeZone) {
    let format = formats.get(timeZone);
    if (!format) {
        format = new Intl.DateTimeFormat('en-CA', {
            timeZone, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
        });
        formats.set(timeZone, format);
    }
    return format;
}
/** An instant as a local day and minutes after midnight. */
export function zonedLocal(instant, timeZone) {
    const parts = Object.fromEntries(formatFor(timeZone).formatToParts(instant).map((part) => [part.type, part.value]));
    return { date: `${parts.year}-${parts.month}-${parts.day}`, minutes: Number(parts.hour) * 60 + Number(parts.minute) };
}
/** A local day and minutes as an instant; two passes so a daylight-saving change is accounted for. */
export function zonedInstant(date, minutes, timeZone) {
    const [year, month, day] = date.split('-').map(Number);
    const wanted = Date.UTC(year, month - 1, day, Math.floor(minutes / 60), minutes % 60);
    let guess = wanted;
    for (let pass = 0; pass < 2; pass++) {
        const seen = zonedLocal(new Date(guess), timeZone);
        const [y, m, d] = seen.date.split('-').map(Number);
        guess += wanted - Date.UTC(y, m - 1, d, Math.floor(seen.minutes / 60), seen.minutes % 60);
    }
    return new Date(guess);
}
//# sourceMappingURL=zone.js.map